import { Card, CardBody, Col } from "reactstrap";
import LargeDropdown from "./LargeDropdown";
import SmallDropdown from "./SmallDropdown";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DropdownSizingTitle } from "../../../../Constants/Constants";
import { DropdownSizingSubTitle } from "../../../../Data/UiKits/Dropdown";
import LargeSplitButton from "./LargeSplitButton";
import SmallSplitButton from "./SmallSplitButton";

const DropdownSizing = () => {
  return (
    <Col md="12">
      <Card className="height-equal">
        <CommonCardHeader title={DropdownSizingTitle} span={DropdownSizingSubTitle} />
        <CardBody className="rtl-dropdown sizing-dropdown">
          <div className="common-flex">
            <LargeDropdown />
            <LargeSplitButton />
            <SmallDropdown />
            <SmallSplitButton />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DropdownSizing;
